<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-11" title="Emergency Services" />
    </div>

    <!-- Search and Create service -->
    <div class="row mb-2">
      <div class="col-sm-4">
        <div class="search-box me-2 mb-2 d-inline-block">
          <div class="position-relative">
            <b-form-input
              type="search"
              class="form-control"
              placeholder="Search Service"
            ></b-form-input>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="text-sm-end">
          <button
            type="button"
            @click="showCreateServiceModal"
            class="btn btn-info btn-rounded mb-2 me-2"
          >
            <i class="mdi mdi-plus me-1"></i>
            {{ $t("menuitems.administration.list.emergency.list.add") }}
          </button>
        </div>
      </div>
    </div>

    <!-- services Table -->
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="allUsers"
        :fields="fields"
        responsive="sm"
        :per-page="0"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #cell(role_name)="row">
          <span>{{ String(row.item.role_name).toUpperCase() }}</span>
        </template>

        <template #cell(created_at)="row">
          <span
            >{{ new Date(row.item.created_at).toLocaleDateString() }}
            {{ new Date(row.item.created_at).toLocaleTimeString() }}</span
          >
        </template>

        <template #cell(is_active)="row">
          <span :class="`badge ${getStatusClass(row.item.is_active)}`">{{
            row.item.is_active ? "Active" : "Disabled"
          }}</span>
        </template>

        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="info"
            class="m-1"
            @click="viewEmergencyServiceDetails(row.item)"
            :disabled="currentUserId === row.item.id"
          >
            View Details
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            class="m-1"
            @click="showUserModifyModal(row.item)"
            :disabled="currentUserId === row.item.id"
          >
            Modify
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1"
            v-show="row.item.is_active == 1"
            @click="deactivateUser(row.item.id)"
            :disabled="currentUserId === row.item.id"
          >
            Deactivate
          </b-button>
          <b-button
            size="sm"
            variant="success"
            class="m-1"
            v-show="row.item.is_active == 0"
            @click="activateUser(row.item.id)"
            :disabled="currentUserId === row.item.id"
          >
            Activate
          </b-button>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end mb-3">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- View Service details modal -->
    <b-modal
      id="view-service-details"
      title="Raise Challan"
      title-class="font-18"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Service Details</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('view-service-details')"
          >
            Cancel
          </button>
        </div>
      </template>
      <div>
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <th scope="row">First Name</th>
                    <td>{{ showService.first_name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Last Name</th>
                    <td>{{ showService.last_name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Email Id</th>
                    <td>{{ showService.email }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Mobile No.</th>
                    <td>{{ showService.mobile }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Vehicle No.</th>
                    <td>{{ showService.vehicle_no }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Service Name</th>
                    <td>{{ showService.service_name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Package Name</th>
                    <td>{{ showService.package_name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Create At</th>
                    <td>
                      {{ new Date(showService.created_at).toLocaleString() }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Create new service modal -->
    <b-modal
      id="create-new-service"
      title="Raise Challan"
      title-class="font-18"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Create New Service</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('create-new-service')"
          >
            Cancel
          </button>
        </div>
      </template>
      <form @submit.prevent="createNewService">
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label>First Name</label>
              <input
                placeholder="Enter First Name"
                v-model="createServiceObj.firstName"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Last Name</label>
              <input
                placeholder="Enter Last Name"
                v-model="createServiceObj.lastName"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Email ID</label>
              <input
                placeholder="Enter Email ID"
                v-model="createServiceObj.email"
                type="email"
                pattern="[^@]+@[^@]+\.[a-zA-Z]{2,6}"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Mobile Number</label>
              <input
                placeholder="Enter Mobile Number"
                v-model="createServiceObj.mobile"
                type="text"
                maxlength="10"
                pattern="[1-9]{1}[0-9]{9}"
                required=""
                class="form-control inp-bg"
                oninvalid="this.setCustomValidity('Please Enter Valid Mobile Number')"
                onchange="try{setCustomValidity('')}catch(e){}"
                oninput="setCustomValidity(' ')"
              />
            </div>
          </div>
          <hr />
          <div class="col-6">
            <div class="mb-3">
              <label>Login Username</label>
              <input
                placeholder="Enter Login Username"
                v-model="createServiceObj.username"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Login Password</label>
              <input
                placeholder="Enter Login Password"
                v-model="createServiceObj.password"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Vehicle Number</label>
              <input
                placeholder="Enter Vehicle Number"
                v-model="createServiceObj.vehicle_no"
                type="text"
                class="form-control inp-bg"
                style="text-transform: uppercase"
                maxlength="10"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Select Service</label>
              <v-select
                class="style-chooser"
                v-model="createServiceObj.emergency_service"
                :reduce="(emergency_service) => emergency_service.id"
                label="service_name"
                :options="allServices"
                required
              ></v-select>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label>Select Package</label>
              <v-select
                class="style-chooser"
                v-model="createServiceObj.package_id"
                :reduce="(package_details) => package_details.id"
                label="package_name"
                :options="packages"
                required
              ></v-select>
            </div>
          </div>
        </div>

        <hr />

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Create New Service <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Update user service modal -->
    <b-modal
      id="update-service-modal"
      title="Raise Challan"
      title-class="font-18"
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Update Service Information</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('update-service-modal')"
          >
            Cancel
          </button>
        </div>
      </template>
      <form @submit.prevent="updateService">
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label>First Name</label>
              <input
                placeholder="Enter First Name"
                v-model="updateServiceObj.first_name"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Last Name</label>
              <input
                placeholder="Enter Last Name"
                v-model="updateServiceObj.last_name"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Email ID</label>
              <input
                placeholder="Enter Email ID"
                v-model="updateServiceObj.email"
                type="email"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Mobile Number</label>
              <input
                placeholder="Enter Mobile Number"
                v-model="updateServiceObj.mobile"
                type="number"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <hr />
          <div class="col-6">
            <div class="mb-3">
              <label>Login Username</label>
              <input
                placeholder="Enter Login Username"
                v-model="updateServiceObj.username"
                type="text"
                class="form-control inp-bg"
                required
                :disabled="true"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Login Password</label>
              <input
                placeholder="Enter Login Password"
                v-model="updateServiceObj.password"
                type="text"
                class="form-control inp-bg"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>RPV Number</label>
              <input
                placeholder="Enter Vehicle Number"
                v-model="updateServiceObj.vehicle_no"
                class="form-control inp-bg"
                style="text-transform: uppercase"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Select Service</label>
              <v-select
                class="style-chooser"
                v-model="updateServiceObj.service_name"
                :options="allServices"
                placeholder="Select Service"
                :reduce="(emergency_service) => emergency_service.id"
                label="service_name"
                required
              ></v-select>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label>Select Package</label>
              <v-select
                class="style-chooser"
                v-model="updateServiceObj.package_name"
                :reduce="(package_details) => package_details.id"
                label="package_name"
                :options="packages"
                required
              ></v-select>
            </div>
          </div>
        </div>

        <hr />

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Save User Details <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import administrationMixin from "@/mixins/administration";
import incidentMixin from "@/mixins/incident";
import Swal from "sweetalert2";
import incident from "../../mixins/incident";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Emergency Services",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [administrationMixin, incidentMixin],
  data() {
    return {
      createServiceObj: {},
      updateServiceObj: {},
      emergencyService: null,
      showService: {},
      allUsers: [],
      allServices: [],
      packages: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "id",
      sortDesc: false,
      filterOn: [],
      filter: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "first_name",
          label: "First Name",
          sortable: false,
        },
        {
          key: "last_name",
          label: "Last Name",
          sortable: false,
        },
        {
          key: "",
          label: "Last Name",
          sortable: false,
        },
        {
          key: "mobile",
          sortable: false,
        },
        {
          key: "is_active",
          sortable: false,
        },

        {
          key: "created_at",
          sortable: false,
        },
        {
          key: "actions",
          sortable: false,
          label: "",
        },
      ],
    };
  },
  async mounted() {
    this.$store.dispatch("layout/changeLoaderValue", true);
    this.$store.dispatch("layout/changeLoaderValue", false);
    this.showAllServices();
    await this.getServices();
  },
  methods: {
    showCreateServiceModal() {
      this.$bvModal.show("create-new-service");
    },

    async getServices() {
      const services = await this.GetEmergencyServices();
      this.allUsers = services.filter(
        (service) => service.role_name === "emergency"
      );
    },

    async showAllServices() {
      try {
        const incidents = await this.GetIncidentMasters();
        this.allServices = incidents.getEmergencyServices;
        this.packages = incidents.getPackages;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },

    async deactivateUser(userId) {
      const payload = {
        id: userId,
        isActive: false,
      };

      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then(async (result) => {
          if (result.isConfirmed) {
            Swal.fire(
              "Account Deactivated!",
              "User account deactivated successfully",
              "success"
            );
            await this.UpdateUser(payload);
            await this.getServices();
          }
        });
        this.$store.dispatch("layout/changeLoaderValue", false);
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to deactivate user", "error");
      }
    },

    async activateUser(userId) {
      const payload = {
        id: userId,
        isActive: true,
      };

      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then(async (result) => {
          if (result.isConfirmed) {
            Swal.fire(
              "Account Activated!",
              "User account activated successfully",
              "success"
            );
            await this.UpdateUser(payload);
            await this.getServices();
          }
        });
        this.$store.dispatch("layout/changeLoaderValue", false);
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to activate user", "error");
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    async createNewService() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.CreateService(this.createServiceObj);
        this.createServiceObj = {};
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("create-new-service");
        await this.GetEmergencyServices();
        Swal.fire(
          "Account Created!",
          "Emergency Service created successfully",
          "success"
        );
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to create emergency service", "error");
      }
    },

    async updateService() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        if (typeof this.updateServiceObj.packageId === "object")
          delete this.updateServiceObj.packageId;

        if (typeof this.updateServiceObj.service_name === "string")
          delete this.updateServiceObj.service_name;

        if (typeof this.updateServiceObj.package_name === "string")
          delete this.updateServiceObj.package_name;

        await this.UpdateEmergencyServices(this.updateServiceObj);
        this.allUsers = await this.GetEmergencyServices();
        this.updateServiceObj = {};
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("update-service-modal");
        Swal.fire(
          "Account Updated!",
          "RPO account updated successfully",
          "success"
        );
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to update RPO", "error");
      }
    },

    showUserModifyModal(selectedUser) {
      this.updateServiceObj = selectedUser;
      this.$bvModal.show("update-service-modal");
    },

    viewEmergencyServiceDetails(selectedService) {
      this.showService = selectedService;
      this.$bvModal.show("view-service-details");
    },

    getStatusClass(status) {
      switch (status) {
        case true:
        case 1:
          return "bg-success";

        case false:
          return "bg-danger";

        default:
          return "bg-info";
      }
    },
  },
  computed: {
    currentUserId() {
      return this.$store.getters["auth/user"].user.id;
    },
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>